module.exports = __webpack_public_path__ + "9a8f57fd25b3c084b6dee64065639971.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/blue/ebewdc.png
// module id = 2667
// module chunks = 0